import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 批量删除选中项")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("导出 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("编辑 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("删除 ")
const _hoisted_12 = { class: "dialog-footer" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("确认")

import { ref, reactive, nextTick } from 'vue'
import { getWarsehouseInfoList, addWarsehouseInfo, delWarsehouseInfo, editWarsehouseInfo, getOrgList, getWarsehouseInfoSelectList } from '@/service/main/warehouse';
import { ElMessage, ElMessageBox } from 'element-plus';
import { exportExcel } from "@/utils/exportExcel";
import Pagination from '@/components/Pagination/index.vue'
import { statusEnum } from '@/utils/enum'

// 获取所属部门数据接口需要的参数

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const params = reactive({
  PageNo: 1,
  PageSize: 10
})
//所属部门下拉框数据定义
const orgEnum: any = ref([])
// 获取所属部门下拉框数据
const getOrg = () => {
  getOrgList(params).then((res) => {
    if (res.code == 200) {
      const { data } = res
      orgEnum.value = data.rows
    }
  }).catch(err => {
    ElMessage.error(err)
  })
}
getOrg()
// 所属工厂下拉框数据定义
const factoryEnum: any = ref([])
// 仓库类型下拉框数据定义
const storeTypeEnum: any = ref([])
// 所属区域列表数据定义
const regionEnum: any = ref([])
// 获取页面下拉框数据
const getFactory = () => {
  const obj = {
    CodeList: ["belong_factory", "ware_type", "belong_region"]
  }
  getWarsehouseInfoSelectList(obj).then((res: any) => {
    if (res.code == 200) {
      const { data } = res
      regionEnum.value = data[0]
      factoryEnum.value = data[1]
      storeTypeEnum.value = data[2]
    }
  }).catch((err: any) => {
    ElMessage.error(err)
  })
}
getFactory()


//查询
const formModel = reactive({
  Name: '',
  Code: '',
  // StortypeName: '',
  PageNo: 1,
  PageSize: 10
});

//仓库类型列表
let tableData = ref([]);

//列表的数据条数
const totalItems = ref<number>(0);

//获取菜单列表
const getTabelData = () => {
  getWarsehouseInfoList(formModel).then(res => {
    if (res.code == 200) {
      const { data } = res;
      const result = data;
      tableData.value = result.rows;
      totalItems.value = result.totalRows;
    } else {
      ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`)
    }
  }).catch(err => {
    console.log(err)
    ElMessage.error(err)
  })
}

getTabelData();

//重置搜索
const resetForm = () => {
  formModel.Name = '';
  formModel.Code = '';
  // formModel.StortypeName = '';
  formModel.PageNo = 1;
  formModel.PageSize = 10;
  getTabelData();
}

//选中的行
const checkRows = ref<{ id: number }[]>([]);

// 选择
const handleSelectionChange = (val: any) => {
  checkRows.value = val;
}
//导出
const handExport = () => {
  let entozh = {
    id: "序号",
    code: "仓库编号",
    name: "仓库名称",
    sysorgName: "所属部门",
    // stortypeName: '仓库类型',
    factoryName: '所属工厂',
    // regionName: '所在区域'
  };
  exportExcel(checkRows.value, entozh, "xlsx", "仓库信息表");
}

//批量删除
const handleBatchDelete = () => {
  const handleArr: number[] = [];
  checkRows.value.forEach(item => {
    handleArr.push(item.id);
  })
  const obj = { id: handleArr };
  ElMessageBox.confirm('是否确认删除？', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    delWarsehouseInfo(obj).then((res: any) => {
      if (res?.code === 200) {
        ElMessage.success('删除成功')
        // 刷新列表
        getTabelData()
      } else {
        ElMessage.error(`删除失败${res?.code}:${JSON.stringify(res.message)}`)
      }
    }).catch((err: any) => {
      console.log(err);
      ElMessage.error(`删除失败${err}`)
    })
  }).catch(() => {
    ElMessage.info('已取消删除')
  })
}

//删除
const deleteRole = (code: number) => {
  const obj = { id: [code] };
  ElMessageBox.confirm('是否确认删除？', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    delWarsehouseInfo(obj).then((res: any) => {
      if (res?.code === 200) {
        ElMessage.success('删除成功')
        // 刷新列表
        getTabelData()
      } else {
        ElMessage.error(`删除失败${res?.code}:${JSON.stringify(res.message)}`)
      }
    }).catch((err: any) => {
      console.log(err);
      ElMessage.error(`删除失败${err}`)
    })
  }).catch(() => {
    ElMessage.info('已取消删除')
  })
}

//窗口类型
const dialogType = ref('add')

const dialogVisible = ref(false);

//操作表单ref
const dialogRef = ref();

//打开窗口
const openDialog = (type: number, scope: any = {}) => {
  if (type == 1) {
    dialogType.value = 'add'
  } else {
    dialogType.value = 'edit'
    addForm.value = Object.assign({}, scope);
  }
  dialogVisible.value = true;
  nextTick(() => {
    dialogRef.value.clearValidate();
  })
}
//添加/编辑
let addForm = ref({
  name: '',
  code: '',
  sysorgName: '',
  factoryName: '',
  // regionName: '',
  // stortypeName: '',
  id: ''
})
// 非汉字校验
var validatorCode = (rule: any, value: any, callback: any) => {
  if (!value) {
    callback()
  } else {
    const reg = /[\u4E00-\u9FA5]/g;
    if (!reg.test(value)) {
      callback();
    } else {
      return callback(new Error("编号不能存在汉字"));
    }
  }
};

//rules
const formRules = {
  name: [{ required: true, message: '仓库名称不能为空', trigger: 'blur' }],
  code: [{ required: true, message: '仓库类型不能为空', trigger: 'blur' }, { validator: validatorCode, trigger: 'blur' }],
  // sysorgName: [{ required: true, message: '所属部门不能为空', trigger: 'blur' }],
  // factoryName: [{ required: true, message: '所属工厂不能为空', trigger: 'blur' }],
  // regionName: [{ required: true, message: '所属区域不能为空', trigger: 'blur' }],
  // stortypeName: [{ required: true, message: '仓库类型不能为空', trigger: 'blur' }]
}



//操作提交
const confirm = () => {
  dialogRef.value.validate((vali: any) => {
    if (vali) {
      //添加
      if (dialogType.value == 'add') {
        addWarsehouseInfo(addForm.value).then(res => {
          if (res.code == 200) {
            ElMessage.success('添加成功');
            getTabelData();
            dialogVisible.value = false;
          } else {
            ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`)
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        editWarsehouseInfo(addForm.value).then(res => {
          if (res.code == 200) {
            ElMessage.success('编辑成功');
            getTabelData();
            dialogVisible.value = false;
          } else {
            ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`)
          }
        }).catch(err => {
          console.log(err)
        })
      }
    } else {
      ElMessage.warning('表单验证失败');
    }
  })

}

//关闭窗口
const closeDialog = () => {
  addForm.value = {
    name: '',
    code: '',
    sysorgName: '',
    factoryName: '',
    // regionName: '',
    // stortypeName: '',
    id: ''
  }
}




return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: _unref(formModel),
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "仓库名称:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(formModel).Name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formModel).Name) = $event)),
                        placeholder: "请选择仓库名称",
                        clearable: "",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "仓库编码:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(formModel).Code,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formModel).Code) = $event)),
                        placeholder: "请选择仓库编码",
                        clearable: "",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search",
                        onClick: getTabelData
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-refresh-right",
                        onClick: resetForm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            icon: "el-icon-delete",
            plain: "",
            disabled: checkRows.value.length == 0,
            onClick: handleBatchDelete
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "info",
            plain: "",
            icon: "el-icon-upload2",
            disabled: checkRows.value.length == 0,
            onClick: handExport
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            icon: "el-icon-plus",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (openDialog(1)))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _hoisted_9
      ]),
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {"width":"100%"},
        onSelectionChange: handleSelectionChange,
        size: "mini"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            align: "center",
            width: "60",
            type: "selection"
          }),
          _createVNode(_component_el_table_column, {
            label: "序号",
            align: "center",
            width: "60",
            type: "index"
          }),
          _createVNode(_component_el_table_column, {
            label: "仓库编号",
            prop: "code",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "仓库名称",
            prop: "name",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "所属部门",
            prop: "sysorgName",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "所属工厂",
            prop: "factoryName",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "260px",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                class: "el-icon-edit",
                onClick: ($event: any) => (openDialog(2, scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                class: "el-icon-delete",
                onClick: ($event: any) => (deleteRole(scope.row.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(Pagination, {
        total: totalItems.value,
        page: _unref(formModel).PageNo,
        "onUpdate:page": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formModel).PageNo) = $event)),
        limit: _unref(formModel).PageSize,
        "onUpdate:limit": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formModel).PageSize) = $event)),
        onPagination: getTabelData,
        style: {"margin-top":"20px","text-align":"center"}
      }, null, 8, ["total", "page", "limit"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((dialogVisible).value = $event)),
      title: dialogType.value == 'add' ? '添加仓库信息' : '编辑仓库信息',
      width: "30%",
      onClose: closeDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_12, [
          _createVNode(_component_el_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirm
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(addForm),
          "label-width": "160px",
          ref_key: "dialogRef",
          ref: dialogRef,
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "仓库编号:",
                      prop: "code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).code,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(addForm).code) = $event)),
                          disabled: dialogType.value == 'edit',
                          placeholder: "请输入仓库编号",
                          clearable: ""
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "仓库名称:",
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).name,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(addForm).name) = $event)),
                          placeholder: "请输入仓库名称",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "所属工厂:",
                      prop: "factoryName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addForm).factoryName,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(addForm).factoryName) = $event)),
                          placeholder: "请选择所属工厂",
                          size: "large",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(factoryEnum.value, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: index,
                                label: item.label,
                                value: item.label
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "所属部门:",
                      prop: "sysorgName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addForm).sysorgName,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(addForm).sysorgName) = $event)),
                          placeholder: "请选择部门",
                          size: "large",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orgEnum.value, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: index,
                                label: item.name,
                                value: item.name
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})